import React from 'react'
import { CircularProgress, Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { UserUploadSlice } from '../../../../reducers'

const UserUploadLoading = () => {
  const progress = useSelector(UserUploadSlice.selectors.selectProgress)
  return (
    <Grid container alignItems='center' direction='column' spacing={2} style={{ padding: 24 }}>
      <Grid item>
        <Typography variant='subtitle1' noWrap>
          <span style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
            Uploading users
            <CircularProgress size='1.5rem' />
            <Typography component='span' color='primary'>
              {progress}%
            </Typography>
          </span>
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='body2' color='textSecondary'>
            The upload will take place in the background, you are free to navigate through The Ark
        </Typography>
      </Grid>
    </Grid>
  )
}

export default UserUploadLoading
